/**
 * A class name for any element that can potentially trigger
 * the onBlur event of the dropdown.
 * If the element contains this class then event bubbling is prevented
 *
 * @see /react-ui/src/forms/Dropdown/components/DropdownInput.tsx stopping propagation
 * @see /react-ui/src/forms/Dropdown/components/InteractableIconContainer.ts element containing this class
 * @type {string}
 */
export var keepFocusOnDropdownInput = 'keepFocusOnDropdownInput';
//# sourceMappingURL=keepFocusOnDropdownInput.js.map